<template>
    <div class="col-2 svg-wrapper">
        <svg width="44px" height="44px" viewBox="0 0 36 44" version="1.1" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
            <title>Iconspace_Flag</title>
            <desc>Created with Sketch.</desc>
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Antarmuka_One-Color-UI-element-4" transform="translate(-632.000000, -146.000000)">
                    <g id="Iconspace_Flag" transform="translate(624.000000, 144.000000)">
                        <polygon id="Shape" points="0 0 48 0 48 48 0 48" />
                        <path
                            d="M11.9941606,24 L40.0058394,24 L40.0058394,6 L11.9941606,6 L11.9941606,24 Z M12,28 L12,46 L8,46 L8,2 L44,2 L44,28 L12,28 Z"
                            id="Shape" fill="#303778" fill-rule="nonzero" />
                    </g>
                </g>
            </g>
        </svg>
    </div>
</template>

<script>
export default {
    name: 'SvgIcon',
}
</script>

<style scoped>
  .svg-wrapper svg {
    height: 20px;
  }
</style>